var _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    viewBox: "0 -35.58 122.88 122.88",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 122.88 51.73"
    },
    xmlSpace: "preserve",
    stroke: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.55,3.48c0.57-4.79,7.86-4.47,7.86,0v1.01c5.29,10.8,15.2,16.77,26.06,19c5.66,1.17,11.59,1.32,17.27,0.63 c5.67-0.69,11.08-2.23,15.7-4.46c7.2-3.47,12.5-8.59,13.91-14.73V3.48c0.57-4.79,7.86-4.47,7.86,0v2.4 c2.18,4.3,5.17,7.74,8.52,10.51c2.87,2.37,6.01,4.28,9.15,5.83v2.98c-1.16-0.55-2.33-1.13-3.48-1.77v9.1h3.48v4.59h-17.67v14.62 h-7.86V37.11H24.41v14.62h-7.86V37.11H0v-4.59h2.91v-9.4C1.95,23.67,0.97,24.18,0,24.67v-3.01c2.75-1.45,5.47-3.17,7.97-5.26 c3.39-2.84,6.39-6.36,8.58-10.79V3.48L16.55,3.48z M66.73,26.93v5.59h-2.69v-5.38c-2.04,0.11-4.09,0.11-6.15,0v5.38h-2.69v-5.6 c-1.77-0.18-3.53-0.45-5.27-0.81c-0.32-0.07-0.64-0.13-0.95-0.21v6.61h-2.69v-7.3c-2.11-0.6-4.16-1.35-6.15-2.25v9.55h-2.69V21.64 c-2.2-1.19-4.29-2.59-6.22-4.2v15.08h-2.69V14.96c-1.51-1.54-2.9-3.24-4.14-5.1v22.67h72.95V11.58c-1.08,1.66-2.41,3.21-3.96,4.65 v16.29H90.7V18.44c-1.84,1.35-3.89,2.57-6.09,3.63l-0.13,0.06v10.39h-2.69v-9.2c-1.96,0.79-4.02,1.47-6.15,2.03v7.18h-2.69v-6.54 c-1.6,0.34-3.24,0.61-4.89,0.81C67.62,26.84,67.18,26.89,66.73,26.93L66.73,26.93z M111.88,18.34v14.19h4.83V21.84 c-1.61-1.01-3.18-2.14-4.69-3.39L111.88,18.34L111.88,18.34z M109.19,32.53V15.87c-1.43-1.45-2.77-3.03-3.98-4.78v21.43H109.19 L109.19,32.53z M13.11,15.21v17.32h3.44V10.91C15.5,12.47,14.34,13.89,13.11,15.21L13.11,15.21z M10.42,32.53V17.82 c-0.24,0.21-0.49,0.43-0.74,0.63C8.37,19.55,7,20.56,5.6,21.48v11.05H10.42L10.42,32.53z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.b5680898c62bca9055ec1a09966ef409.svg";
export { ForwardRef as ReactComponent };